"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var globals_1 = require("./globals");
var constants_1 = require("./constants");
var attach_listener_1 = require("./attach-listener");
var attach_shared_listeners_1 = require("./attach-shared-listeners");
var manage_subscribers_1 = require("./manage-subscribers");
exports.createOrJoinSocket = function (webSocketRef, url, setReadyState, optionsRef, setLastMessage, startRef, reconnectCount) {
    if (optionsRef.current.share) {
        if (globals_1.sharedWebSockets[url] === undefined) {
            setReadyState(constants_1.ReadyState.CONNECTING);
            globals_1.sharedWebSockets[url] = new WebSocket(url, optionsRef.current.protocols);
            attach_shared_listeners_1.attachSharedListeners(globals_1.sharedWebSockets[url], url);
        }
        else {
            setReadyState(globals_1.sharedWebSockets[url].readyState);
        }
        var subscriber_1 = {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState,
            optionsRef: optionsRef,
            reconnectCount: reconnectCount,
            reconnect: startRef,
        };
        manage_subscribers_1.addSubscriber(url, subscriber_1);
        webSocketRef.current = globals_1.sharedWebSockets[url];
        return function () {
            manage_subscribers_1.removeSubscriber(url, subscriber_1);
            if (!manage_subscribers_1.hasSubscribers(url)) {
                try {
                    globals_1.sharedWebSockets[url].onclose = function () { };
                    globals_1.sharedWebSockets[url].close();
                }
                catch (e) {
                }
                delete globals_1.sharedWebSockets[url];
            }
        };
    }
    else {
        setReadyState(constants_1.ReadyState.CONNECTING);
        webSocketRef.current = new WebSocket(url, optionsRef.current.protocols);
        return attach_listener_1.attachListeners(webSocketRef.current, {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState
        }, optionsRef, startRef.current, reconnectCount);
    }
};
//# sourceMappingURL=create-or-join.js.map